import { DISCIPLINARY_ACTIONS_STATUS } from 'Deer/pages/Team/DirectReports/DisciplinaryActions/constants';

import { ConfirmationModal } from 'uiToolkitV1/ConfirmationModal';

import type { DisciplinaryNoteRow } from '../MyCompanyDisciplinaryActionsGrid';

type ApproveAllConfirmationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  selectedNoteIds: number[];
  rows: DisciplinaryNoteRow[];
  onApprove: (noteIds: number[]) => void;
};

export const ApproveAllConfirmationModal = ({
  isOpen,
  onClose,
  selectedNoteIds,
  rows,
  onApprove,
}: ApproveAllConfirmationModalProps) => {
  const approvalEligibleNoteIds = rows
    .filter((row) => selectedNoteIds.includes(row.NOTE_ID) && row.STATUS === DISCIPLINARY_ACTIONS_STATUS.CREATED)
    .map((row) => row.NOTE_ID);

  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      title="Approve"
      body={`Do you want to approve all ${approvalEligibleNoteIds.length} disciplinary notes? The manager will be able to publish these notes to the employee after you approve them.`}
      cancelText="Cancel"
      onCancel={onClose}
      continueText="Approve"
      onContinue={() => onApprove(approvalEligibleNoteIds)}
      disabled={false}
      cancelButtonProps={{}}
      continueButtonProps={{
        disabled: approvalEligibleNoteIds.length === 0,
      }}
      modalContentProps={{
        maxWidth: '600px',
      }}
    />
  );
};
